import { createClient } from '@supabase/supabase-js'
import {
	Article,
	Company,
	Job,
	Team,
	User,
} from 'src/graphql/__generated__/graphql'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export type SearchResult = {
	company: Company | null
	article: Article | null
	user: User | null
	team: Team | null
	job: Job | null
	company_count: number
	article_count: number
	user_count: number
	team_count: number
	job_count: number
}
